import { render, staticRenderFns } from "./waitConfirmLogistics.vue?vue&type=template&id=a7f754b6&scoped=true&"
import script from "./waitConfirmLogistics.vue?vue&type=script&lang=js&"
export * from "./waitConfirmLogistics.vue?vue&type=script&lang=js&"
import style0 from "./waitConfirmLogistics.vue?vue&type=style&index=0&id=a7f754b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f754b6",
  null
  
)

export default component.exports